import requestFormData from '../../utils/requestFormData';
import request from '../../utils/request';

export function doGetClaims(params) {
  return request(`/claims`, {
    method: 'GET',
    params,
  });
}

export function doGetClaim(id: number) {
  return request(`/claims/${id}`, {
    method: 'GET',
  });
}

export function doGetActiveClaimCount() {
  return request(`/claims/active-claims-count`, {
    method: 'GET',
  });
}

export function doUpdateClaim(params) {
  const id = params.get('id');
  params.delete('id');

  return requestFormData(`/claims/${id}`, {
    method: 'PATCH',
    data: params,
  });
}

export function doRemoveClaimImage(id: number) {
  return request(`/claims/${id}/image`, {
    method: 'DELETE',
  });
}
